// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__2_Op4","title":"About_title__23UMb","subtitle":"About_subtitle__1ElLv"};